import Reveal, { Stagger, StaggerItem } from "@/components/motion/Reveal";


const STATS = [
  { n: "30+", l: "Years of operation", s: "Since 1995" },
  { n: "II", l: "Generations", s: "Rudra → Anurag" },
  { n: "1", l: "State of focus", s: "Karnataka only" },
  { n: "B2G · B2B", l: "Client mandate", s: "Govt & MNCs" },
];

const TIMELINE = [
  {
    year: "1982",
    title: "Delhi",
    body:
      "Rudra Singh moves from Patiala to Delhi with his family — the setting for his academic and early professional years.",
  },
  {
    year: "1991",
    title: "Family",
    body:
      "Rudra Singh marries Dr. Swity Singh, Pediatric Neurosurgeon at AIIMS Delhi.",
  },
  {
    year: "1993",
    title: "Second Generation",
    body:
      "Anurag Singh is born — the next custodian of the Rudra name.",
  },
  {
    year: "1995",
    title: "The House is Founded",
    body:
      "Sri Rudra Singh — IIT Delhi graduate and former IPS officer — establishes RUDRA EMPIRE in Karnataka, dedicated to the strategic acquisition and consolidation of land.",
  },
  {
    year: "2011",
    title: "Succession",
    body:
      "Following the passing of the founder, ownership of RUDRA EMPIRE transfers to Dr. Anurag Singh, who assumes the role of Chairman and Legal Owner.",
  },
  {
    year: "2011 → Present",
    title: "Continuity",
    body:
      "Day-to-day management is entrusted, under Power of Attorney, to Mr. Jasprit Singh. Dr. Anurag Singh, having completed his medical education, now leads RUDRA EMPIRE full-time.",
  },
];

export default function Milestones() {
  return (
    <section
      id="milestones"
      data-testid="milestones-section"
      className="relative bg-[#0A0A0D] py-32 md:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-8">
            <div className="overline mb-6">Legacy</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-neutral-50">
              Three decades. <br />
              One <span className="italic text-[#D4AF37]">mandate.</span>
            </h2>
          </div>
        </div>

        {/* Stats row */}
        <Stagger className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-24 border-t border-white/8 pt-10" gap={0.12}>
          {STATS.map((s) => (
            <StaggerItem key={s.l}>
              <div data-testid={`stat-${s.l.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <div className="font-display text-5xl md:text-6xl lg:text-7xl text-[#D4AF37] leading-none">
                  {s.n}
                </div>
                <div className="mt-4 text-neutral-100 text-sm tracking-wider uppercase">
                  {s.l}
                </div>
                <div className="mt-1 text-xs text-neutral-500">{s.s}</div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        {/* Timeline */}
        <div className="relative">
          <div className="absolute left-2 md:left-1/2 top-0 bottom-0 w-px bg-white/10" />
          <div className="space-y-16">
            {TIMELINE.map((t, i) => {
              const rightSide = i % 2 === 1;
              return (
                <Reveal
                  key={t.year}
                  variant="up"
                  amount={0.4}
                  className="relative grid grid-cols-1 md:grid-cols-2 gap-8 items-start"
                >
                  <div data-testid={`timeline-${t.year.toLowerCase()}`} className="contents">
                  {/* Dot */}
                  <div className="absolute left-1 md:left-1/2 top-2 -translate-x-1/2 w-3 h-3 bg-[#D4AF37]" />

                  {/* Left column */}
                  <div className={`pl-10 md:pl-0 ${rightSide ? "md:invisible md:h-0" : "md:pr-14 md:text-right"}`}>
                    {!rightSide && (
                      <>
                        <div className="overline text-[#D4AF37] mb-3">{t.year}</div>
                        <div className="font-display text-3xl text-neutral-50 leading-tight">
                          {t.title}
                        </div>
                        <p className="mt-4 text-neutral-400 leading-relaxed">
                          {t.body}
                        </p>
                      </>
                    )}
                  </div>

                  {/* Right column */}
                  <div className={`pl-10 md:pl-14 ${!rightSide ? "md:invisible md:h-0" : ""}`}>
                    {rightSide && (
                      <>
                        <div className="overline text-[#D4AF37] mb-3">{t.year}</div>
                        <div className="font-display text-3xl text-neutral-50 leading-tight">
                          {t.title}
                        </div>
                        <p className="mt-4 text-neutral-400 leading-relaxed">
                          {t.body}
                        </p>
                      </>
                    )}
                  </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        {/* Marquee */}
        <div className="mt-28 overflow-hidden border-y border-white/8 py-6">
          <div className="flex whitespace-nowrap animate-marquee">
            {Array.from({ length: 2 }).map((_, k) => (
              <div key={k} className="flex items-center gap-14 pr-14">
                {[
                  "Welcome to the World of Business",
                  "Since 1995",
                  "Karnataka Only",
                  "For Government",
                  "For Multinationals",
                  "Discretion · Diligence · Delivery",
                  "One Mandate",
                ].map((w) => (
                  <span
                    key={w + k}
                    className="font-display italic text-3xl md:text-4xl text-neutral-500"
                  >
                    {w} <span className="text-[#D4AF37] mx-6">✦</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
